<template>
  <SimpleModal
    size="small"
    :is-open="state.show"
    :type="state.type"
    :class="`${state.type}-modal`"
    @close="cancel"
  >
  <div class="flex flex-col gap-y-6 py-8 px-12" style="text-wrap: balance;">
   <div
      class="flex flex-col items-center w-full gap-y-2"
      :class="{
        'text-red-400': state.type === 'danger',
        'text-blue-400': state.type === 'info'
      }"
      >
        <ExclamationCircleIcon v-if="state.type === 'danger'" class="w-10 h-10  mx-auto" />
        <InformationCircleIcon v-if="state.type === 'info'" class="w-10 h-10  mx-auto" />
        <h3 class="font-semibold text-center w-full inline-block text-xl">{{ state.title }}</h3>
    </div>

    <p class="text-center text-base font-medium pb-2">
      {{ state.body }}
        <ul
          v-if="state.items.length > 0"
          class="mt-2 font-semibold"
        >
        <li v-for="item in state.items">
          {{ item }}
        </li>
      </ul>
    </p>

    <div
        class="footer-buttons flex flex-col sm:flex-row gap-3 justify-center"
      >
        <button
          type="button"
          @click="accept"
          class="w-full inline-flex justify-center rounded-md border-2 shadow-sm px-5 py-3 text-base sm:w-auto sm:text-sm uppercase font-semibold"
          :class="{
            'border-red-400 bg-red-200 text-red-400': state.type === 'danger',
            'border-blue-400 bg-blue-200 text-blue-400': state.type === 'info'
          }"
        >
          {{ state.confirmText }}
        </button>
        <button
          type="button"
          v-if="state.cancelText"
          @click="cancel"
          class="w-full inline-flex justify-center rounded-md  px-5 py-3  text-base text-gray-600 sm:w-auto sm:text-sm uppercase font-semibold"
        >
          {{ state.cancelText }}
        </button>
      </div>
    </div>
  </SimpleModal>
</template>

<script setup>
import SimpleModal from '@/Components/Modals/SimpleModal.vue'
import { useConfirmDialog } from '@/Composables/confirm-dialog'
import { ExclamationCircleIcon, InformationCircleIcon } from '@heroicons-2/vue/24/outline'

const { state, accept, cancel } = useConfirmDialog()
</script>
